module.exports = __webpack_public_path__ + "img/mountains-houses.ad596182.jpeg";